
    import { Component, Vue, Watch } from 'vue-property-decorator'
    const dr_1 = require('./../../../assets/imgs/dr_1.png'),
        dr_2 = require('./../../../assets/imgs/dr_2.png'),
        dr_3 = require('./../../../assets/imgs/dr_3.png');
    @Component({
        name: 'DashResearch'
    })
    export default class DashResearch extends Vue {
        private drContentList: Array<any> = [
            { icon: dr_1, title: '押题准', text: '多次押中中考考题', info1: '勤学的讲义已经多次压中中考考题，名<br />校小升初考试，以及四十五中，五十中，<br />四十二中，寿春中学，一中、六中，八<br />中，168中学等初高中学校期中期末考<br />试题。', info2: '每次都完美错过做过的题，考试的题<br />型很少见' },
            { icon: dr_2, title: '选题精', text: '自主研发讲义', info1: '勤学使用的教材是自主研发的讲义，老<br />师经过层层审核，制定出来的教研体系<br />符合学生的认知规律及考试命题规律，<br />同时实行分层教学，不同班型使用不同<br />层级的讲义。', info2: '做的题很多，但是提分效果差，题海<br />战术的效果越来越差' },
            { icon: dr_3, title: '模块化', text: '解决一类题型', info1: '勤学每节课所选用的例题都是围绕知识<br />点展开的，难度层层递进，不仅让学生<br />理解知识点更保证学生会解每一道题，<br />每一类题。再通过课前测课后测不断巩<br />固知识点。', info2: '一道题换一种说法就不会做，反反复<br />复总是丢分' }
        ]
    }
